import { useParams } from "react-router-dom";

import { useGetPaymentQuery } from "modules/transactions";

import type { ObjectWithId } from "../../../utils/ObjectWithId";

export function useRuleScoreItem() {
  const { id } = useParams<ObjectWithId>();
  const { data } = useGetPaymentQuery({ id });

  return { data };
}
